import { LangType } from '../../helpers/lang';
import { buildParams } from '../../helpers/path';
import { ServiceType } from '../../helpers/services';
import { PaginationRequest, PaginationType } from '../../types/pagination';
import {
  CustomCacheRequest,
  IdValue,
  InfiniteScrollRequest,
  SortRequest,
  WithArchiveRequest,
} from '../../types/props';
import { managerApiUrl } from './manager-api';
import { BranchType } from './branches-api';
import { TreeType } from './trees-api';
import { baseFetch } from './utils.ts/base-fetch';
import { tzOffset } from '../../helpers/date-time';

export type QrCodeDynamicType = 'AUTH_COMMON_DYNAMIC';

export type QrCodeType = {
  created_at: string;
  description: LangType;
  form: [];
  id: string;
  is_show_lead: boolean;
  name: LangType;
  place_id: number;
  services: ServiceType[];
  tags: IdValue[];
  tree_id: string | number;
  tree: TreeType;
  type?: QrCodeDynamicType;
  is_attached?: boolean;
  is_deleted?: boolean;
  code?: string;
  branch?: BranchType;
  menu_ids?: string[];
  iiko_menu_ids?: string[];
  is_distance?: boolean;
};

const baseUrl = `${managerApiUrl}/qr`;

const withType = (type?: QrCodeDynamicType) => {
  return `${baseUrl}${type === 'AUTH_COMMON_DYNAMIC' ? '/dynamic' : ''}`;
};

export const postQr = async (
  params: Partial<QrCodeType>,
  type?: QrCodeDynamicType,
): Promise<QrCodeType> => {
  const response = await baseFetch(withType(type), {
    method: 'POST',
    body: JSON.stringify({ ...params, type }),
  });
  return response;
};

export const putQr = async (
  params: Partial<QrCodeType>,
  type?: QrCodeDynamicType,
): Promise<QrCodeType> => {
  const response = await baseFetch(`${withType(type)}/${params.id}`, {
    method: 'PUT',
    body: JSON.stringify({ ...params, type }),
  });
  return response;
};

export type FetchQrListRequest = {
  name?: string;
  description?: string;
  id?: string;
  tags?: string;
  services?: string;
  is_attached?: string;
  places?: string;
  created_at?: string;
  from?: string;
  to?: string;
  type?: QrCodeDynamicType;
} & PaginationRequest &
  WithArchiveRequest &
  SortRequest &
  CustomCacheRequest &
  InfiniteScrollRequest;

export const fetchQrList = async (
  params: FetchQrListRequest,
): Promise<PaginationType & { qr: QrCodeType[] }> => {
  const { customCache, type, ...other } = params;
  const response = await baseFetch(
    `${withType(type)}${buildParams({ ...other, offset: -tzOffset })}`,
    { customCache },
  );
  return response;
};

export const deleteQr = async (id: string, type?: QrCodeDynamicType): Promise<void> => {
  const response = await baseFetch(`${withType(type)}/${id}`, {
    method: 'DELETE',
  });
  return response;
};

export const restoreQr = async (id: string, type?: QrCodeDynamicType): Promise<void> => {
  const response = await baseFetch(`${withType(type)}/${id}/restore`, { method: 'POST' });
  return response;
};

export const fetchQr = async (id: string, type?: QrCodeDynamicType): Promise<QrCodeType> => {
  const response = await baseFetch(`${withType(type)}/${id}`);
  return response;
};
